var React = require('react');

function IconLocationSuggestion (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 19C8 19 15 13 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 13 8 19 8 19Z","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconLocationSuggestion.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none"};

module.exports = IconLocationSuggestion;

IconLocationSuggestion.default = IconLocationSuggestion;
